import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import Input from 'components/Input';
import * as Dropdown from 'components/Dropdown';

const TestSelectionComponent = ({
  nullValueValidator,
  isSlopeOrCorrelation,
  ...props
}) =>
  <div className="flex align-end mb-20">
    <div className="main-dropdown flex-grow">
      <p className="main-dropdown__label">
        Test Parameter
      </p>

      <Field
        {...props}
        name="testSelection"
        placeholder="Select a Test Parameter"
        component={Dropdown.ReduxFormWrapper}
      />
    </div>

    <span className="ml-10 mr-10 mb-10">=</span>

    <Field
      type="number"
      id="null-value"
      name="nullValue"
      component={Input}
      label="Null Value"
      validate={nullValueValidator}
      disabled={isSlopeOrCorrelation}
      wrapperClassName="flex-grow relative"
    />
  </div>;

TestSelectionComponent.propTypes = {
  isSlopeOrCorrelation: PropTypes.bool.isRequired,
  nullValueValidator: PropTypes.func.isRequired
};

export default TestSelectionComponent;
